<template>
  <div class="container py-5">

    <div class="level">
      <div class="level-left buttons flex-row mb-0">
        <div class="title is-4 mr-3 ml-1">
          Installation Project Summary
        </div>
      </div>

      <!-- <div class="level-right buttons">
        <v-fade-transition>
          <button
            v-if="selected.length > 0" 
            class="button" @click="launchConfirmDelete()">
            <span class="icon is-medium">
              <i class="fas fa-trash has-text-danger"></i>
            </span>
            <span>
              Delete {{ selected.length }} Selected Skids
            </span>
          </button>
        </v-fade-transition>
        <button
          class="button is-primary"
          @click="creatingSkid = true">
          Create a Skid
        </button>
      </div> -->
    </div>

    <article 
      v-if="!loading && installationProjects.length == 0" 
      class="message is-info is-fullwidth mt-3">
      <div class="message-body">
        There are no projects with installation information.
      </div>
    </article>

    <table 
      v-if="loading || installationProjects.length > 0"
      class="table is-hoverable is-fullwidth is-responsive">

      <thead>
        <tr>
          <th 
            v-for="(header, headerIndex) in headers" 
            :key="headerIndex">
            {{ header.label }}
          </th>
        </tr>
        <tr v-if="loading">
          <th :colspan="headers.length + 2" class="py-0 px-0 is-naked">
            <v-progress class="is-fullwidth" v-model="loading"/>
          </th>
        </tr>
      </thead>

      <tbody v-if="installationProjects.length > 0">
        <tr 
          class="pointer v-centered"
          v-for="project in installationProjects"
          :key="project.project_id">
          <td 
            v-for="(header, headerIndex) in headers"
            :key="`column-${headerIndex}`"
            :data-title="header.label">
            <span v-if="helpers.isFunction(header.field)">
              {{ header.format ? header.format(header.field(project)) : header.field(project) }}
            </span>
            <span v-else>
              {{ header.format ? header.format(project[header.field]) : project[header.field] }}
            </span>
          </td>
        </tr>
      </tbody>

    </table>

    <v-pagination 
      v-if="pagination.pages > 1"
      :value="pagination.page"
      @input="changePage"
      :length="pagination.pages"/>

  </div>
</template>

<script>
import VPagination from '@/components/base/VPagination'
// import VFadeTransition from '@/components/transitions/VFadeTransition'
import VProgress from '@/components/base/VProgress'
import filters from '@/filters'
import helpers from '@/helpers'

import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  components: { 
    VPagination, VProgress
  },
  data() {
    return {
      headers: [
        { label: 'Project Name', field: 'project_name' },
        { label: 'Total Skids', field: 'skids' },
        { label: 'Skids Sent', field: 'skids_sent' },
        { label: 'Total Pieces', field: 'pieces', format: v => filters.CommaSep(v, 0) },
        { label: 'Total SQFT', field: 'total_sqft', format: v => filters.CommaSep(v, 0) },
        { label: 'SQFT Sent', field: 'sqft_sent', format: v => filters.CommaSep(v, 0) },
        { label: 'SQFT Installed', field: 'sqft_installed', format: v => filters.CommaSep(v, 0) },
        { label: '% SQFT Installed (of sent)', 
          field: v => v.sqft_installed / v.sqft_sent, 
          format: v => filters.Percentage(v, 0) }
      ],
      helpers: helpers
    }
  },
  computed: {
    ...mapState("installationSummary", [
      "installationProjects", "loading", "pagination", "filters"
    ])
  },
  watch: {
    'pagination.page'(page) {
      this.getInstallationProjects({ page: page });
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("installationSummary", [
      "getInstallationProjects"
    ]),
    ...mapMutations("installationSummary", [
      "changePage", "setFilter"
    ]),
    initialize() {
      this.getInstallationProjects();
    },
    viewProjectSkids(project) {
      this.$router.push({ 
        name: 'SkidList', 
        query: {
          project_id: project.project_id
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/table.scss';
@import '@/styles/flexbox.scss';
</style>